import { useEffect, useState } from "react";
import WalletDetails from "../../components/supervisor/WalletComponents/WalletDetails";
import "./WalletPage.scss";
import WalletCustomerInfo from "../../components/supervisor/WalletComponents/WalletCustomerInfo";

const WalletPage = () => {
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [walletInfo, setWalletInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recharge,setRechage] = useState(false);
  // const [state, setState] = useState(0);

  useEffect(() => {
    if (selectedWallet != null) {
      // The wallet information will be fetched by WalletCustomerInfo component
      // when selectedWallet changes, so we don't need to fetch it here
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [selectedWallet]);

  // useEffect(() => {
  //   if (state === 1) {
  //     setLoading(false);
  //   }
  //   setState(1);
  //   // setLoading(false);
  // }, [walletInfo]);

  return (
    <div className="walletsMain">
      <div className={`columnWalletDetails${selectedWallet ? "" : " columnWalletDetails--full"}`}>
        <WalletDetails
          setSelectedWallet={setSelectedWallet}
          selectedWallet={selectedWallet}
          walletInfo={walletInfo}
          setWalletInfo={setWalletInfo}
          loading={loading}
          setLoading={setLoading}
          recharge={recharge}
          setRechage={setRechage}
        ></WalletDetails>
      </div>
      {selectedWallet && (
        <div className="columnWalletMovements">
          {!loading &&(
            <WalletCustomerInfo
              walletInfo={walletInfo}
              setWalletInfo={setWalletInfo}
              selectedWallet={selectedWallet}
            ></WalletCustomerInfo>
          )}
        </div>
      )}
    </div>
  );
};

export default WalletPage;
